
import Vue from "vue";
export default Vue.extend({
  props: ["items", "tab", "isEn"],
  data: () => ({
    logoImg: require("../assets/aslp-logo.png"),
    menuOpen: false,
  }),
  methods: {
    navigate(path: string) {
      this.menuOpen = false;
      this.$router.push(path);
    }
  }
});
